module.exports = __webpack_public_path__ + "static/img/water.fc6c214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/displacements/water.jpg
// module id = n8kN
// module chunks = 1